import { render, staticRenderFns } from "./TipoRecomendacao.vue?vue&type=template&id=382a16fc"
import script from "./TipoRecomendacao.vue?vue&type=script&lang=js"
export * from "./TipoRecomendacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports